import { render, staticRenderFns } from "./CarbonEmission.vue?vue&type=template&id=7c3e37d1&scoped=true&"
import script from "./CarbonEmission.vue?vue&type=script&lang=js&"
export * from "./CarbonEmission.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmission.vue?vue&type=style&index=0&id=7c3e37d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e37d1",
  null
  
)

export default component.exports